import Permission from "./Permission";
import PrintKeys from "./PrintKeys";
import User from "./User";
import Roles from "./Roles";
import Services from './Services'
import VideoCategory from './VideoCategory'
import Instructores from './Instructores'
import Talent from './Talent'
import Members from './Members'
import Appointments from './Appointments'
import Video from './Video'
import Messages from './Messages'
import Sessions from './Sessions'
import MemberOpendSeassions from './MemberOpendSeassion'
import Survey from './Survey'
import Notification from './Notification'
export default {
  Permission,
  Survey,
  Messages,
  User,
  Roles,
  Sessions,
  PrintKeys,
  Notification,
  MemberOpendSeassions,
  Services, VideoCategory, Instructores, Talent, Members, Appointments,Video
};
